import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useUpdateEmployeeEducationDetails(
  closeModal,
  iscloseModalTrue,
  defaultValues,
  reset
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.EMPLOYEE_EDUCATION_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (iscloseModalTrue) {
          closeModal();
        }
        SuccessToast({text: data.message})
        reset(defaultValues);
        queryClient.invalidateQueries('get-employee-educational-details');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
